import {Component, HostBinding} from "@angular/core";

@Component({
    selector: "fui-page-body",
    styleUrls: ["./page-body.component.scss"],
    templateUrl: "./page-body.component.html",
    standalone: false
})
export class FUIPageBodyComponent {
    @HostBinding("attr.tabIndex") public tabIndex: number = 1;
}
